import { render } from "./BG_intelligentDecision.vue?vue&type=template&id=82aba03c&scoped=true"
import script from "./BG_intelligentDecision.vue?vue&type=script&lang=js"
export * from "./BG_intelligentDecision.vue?vue&type=script&lang=js"

import "./BG_intelligentDecision.vue?vue&type=style&index=0&id=82aba03c&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82aba03c"]])

export default __exports__